import { CompanyTableInfo } from '@aibees/elephant/feature/search-table-company';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { UserRelation } from '@aibees/shared/definition';
import { useMemo } from 'react';
import { SearchType } from '../../types';
import { useOwnerData } from './use-owner-data';

interface UseCurrentOwnerParams {
  selectedUser?: UserRelation;
  item?: CompanyTableInfo | PeopleTableInfo;
  searchTypeOverride?: SearchType;
}

export function useCurrentOwner({
  selectedUser: propsSelectedUser,
  item,
  searchTypeOverride,
}: UseCurrentOwnerParams) {
  const ownerData = useOwnerData(searchTypeOverride);

  return useMemo(() => {
    // Only fall back to the read-data context when no `item` was passed.
    // Otherwise we'd return the drawer record's owner for a different
    // record (e.g. a lookalike card or buying-team member).
    return propsSelectedUser || (item ? item.user : ownerData);
  }, [propsSelectedUser, item, ownerData]);
}
